import { Col, Row, Spin, DatePicker, Button, Input } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import AppTable from "../../components/AppTable/AppTable";
import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DownloadOutlined, RedoOutlined } from '@ant-design/icons';

const Availablecabs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [availablecabs, setavailablecabs] = useState([]);
  const [copyavailablecabs, setcopyavailablecabs] = useState([]);
  const [fromdate, setfromdate]: any = useState(moment());
  const [todate, settodate]: any = useState(moment());
  const [totalCount, setTotalCount] = useState(0);
  const [SearchText, setsearchText]: any = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Role, setRole]: any = useState(localStorage.getItem("roleid"));
  const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));


  const GetAvaialblecabs = (
  ) => {
    setIsLoading(true);
    const options: any = {
      params: {
        branchid: branchid
      },
    };
    axiosGet(UrlConstants.availablecabs, options)
      .then((resp: any) => {
        resp.data.forEach((e: any) => {
          e.key = e.cabid.toString();
        });
        setIsLoading(false);
        setavailablecabs(resp.data);
        setcopyavailablecabs(resp.data);
        setTotalCount(resp.tablelength);
      })
      .catch(function (error: any) {
        setIsLoading(false);
        if (error.response) {
          console.log(error.response.data, error.response.status);
          setavailablecabs([]);
          setcopyavailablecabs([]);
        }
      });
  };


  const columns = [
    {
      title: "Cab Id",
      dataIndex: "cabid",
      width: 100,
      key: "CabId",
    },

    {
      title: "Location",
      dataIndex: "livelocation",
      key: "Location",
      width: 620,
      render: (text: string) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Waiting time",
      dataIndex: "waitingtime",
      width: 100,
      key: "Reamraks",
    },

  ];


  useEffect(() => {
    GetAvaialblecabs();
  }, []);

  const onSearchchange = (e: any) => {
    setsearchText(e.target.value);
    globalSearch(e.target.value);
  };

  const globalSearch = (searchText: string) => {
    const lowerSearchText = searchText.toLowerCase();
    const filteredData = availablecabs.filter((value: any) => {
      const properties = [
        value.cabid?.toString() || "",
        value.livelocation?.toString() || "",
      ].map((prop) => prop.toLowerCase());

      return properties.some((prop) => prop.includes(lowerSearchText));
    });

    setcopyavailablecabs(filteredData);
    setFilteredData(filteredData);
  };

  return (
    <div className="booking-child-routes">
      <div className="booking-child-routes-button-section">

        <Row align="middle" gutter={16} style={{ paddingBottom: 10 }}>

          <Col span={6}>
            <span
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Times New Roman",
              }}
            >
              Available Vehicles
            </span>
          </Col>

          <Col span={6}>
            <span
              style={{
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Count : {availablecabs.length}
            </span>
          </Col>

          <Col span={1} >
            <Button
              icon={<RedoOutlined />}
              type="primary"
              onClick={() => GetAvaialblecabs()}
              block
            >

            </Button>
          </Col>

          <Col span={6} offset={5}>
            <Input
              placeholder="Search Text"
              className="search"
              onChange={onSearchchange}
              allowClear
            />
          </Col>

        </Row>
        <div>
          <Spin tip="Loading..." spinning={isLoading}>
            <AppTable
              columns={columns}
              data={copyavailablecabs}
              enablePagination={true}
              defaultPageSize={100}
              scroll={{ x: "max-content" }}
            ></AppTable>
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default Availablecabs;
